import React from 'react'
import { connect } from 'react-redux'
import { Typography, Card, Layout, message } from 'antd'
import axios from 'axios'; 
import ClientHeader from '../components/header'
import ClientFooter from '../components/footer';
import RegisterForm from '../components/RegisterForm'
import { LoadingContent, SuccessContent, ErrorContent } from '../components/RegisterStatus'
import { mapCustomerToFormValues } from './registerUtils'

const { Title } = Typography;
const { Content } = Layout;

class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //status : init | loading | success | error | verification_failed
      status: 'init',
      errorMessage: '',
      formValues: mapCustomerToFormValues(props.customer),
    };
  }

  componentDidMount() {
    const { customer } = this.props;
    if (customer?.subscriptionId === undefined) {
      this.setState({
        status: 'verification_failed',
        errorMessage: '',
      });
    }
  }

  componentDidUpdate(prevProps) {
    // props.customer 改變時，更新 formValues 和清空訊息
    if (prevProps.customer !== this.props.customer) {
      this.setState({
        formValues: mapCustomerToFormValues(this.props.customer),
        errorMessage: '',
      });
    }
  }

  handleFinish = async (values) => {
    this.setState({
      status: 'loading',
      errorMessage: '',
    });

    try {
      const { customer } = this.props;
      if (customer?.subscriptionId === undefined) {
        this.setState({
          status: 'error',
          errorMessage: 'Please verify your subscription information first！',
        });
        message.error('Please verify your subscription information first！');
        return;
      }
      const response = await axios.post(
        process.env.REACT_APP_API_URL + '/user/register/' + customer.subscriptionId,
        {
          ...values,
        },
        {
          withCredentials: true 
        }
      );

      if (response.status === 201) {
        this.setState({
          status: 'success',
          errorMessage: '',
        });
        message.success('Registration successful, redirecting to the system...');
      }
    } catch (error) {
      this.setState({
        status: 'error',
        errorMessage: error.response?.data?.message || 'Registration failed, please try again later.',
      });
      message.error(error.response?.data?.message || 'Registration failed, please try again later.');
    }
  };

  renderInitContent = () => {
    const { errorMessage } = this.state;
    const { customer } = this.props;
    const initialValues = mapCustomerToFormValues(customer);
    return (
      <>
        <Title level={3} style={{ textAlign: 'center' }}>
          Register your account
        </Title>
        <RegisterForm
          onFinish={this.handleFinish}
          errorMessage={errorMessage}
          initialValues={initialValues}
        />
      </>
    );
  };

  renderContent() {
    const { status, errorMessage } = this.state;
    switch(status) {
      case 'loading':
        return <LoadingContent />;
      case 'success':
        return <SuccessContent />;
      case 'verification_failed':
        return <ErrorContent errorMessage={errorMessage} />;
      default:
        return this.renderInitContent();

    }
  }

  render() {
    return (
      <Layout style={{ minHeight: '100vh' }}>
       <ClientHeader/>
        <Content style={{ padding: '2rem' }}>
          <div style={{ flex: 1, maxWidth: 520, margin: '2rem auto' }}>
            <Card  style={{ boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }} variant="filled">
              {this.renderContent()}
            </Card>
          </div>
        </Content>
         <ClientFooter />
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  customer: state.customer,
});

export default connect(mapStateToProps)(Register);
